import { useTranslation } from "react-i18next";
import { groupLabel } from "../utils/identity";
import "./IdentityGroups.css";

/** An account's identity-provider groups as badges (display name, falling back
 * to the external id). Shared by the account settings and the user admin. */
export default function IdentityGroups({ groups }) {
  const { t } = useTranslation();
  const list = Array.isArray(groups) ? groups : [];
  if (list.length === 0) return <span className="ds-help">{t("identity.noGroups")}</span>;
  return (
    <ul className="identity-groups" aria-label={t("identity.groups")}>
      {list.map((g) => (
        <li key={g.id || `${g.provider}:${g.external_id}`} className="ds-badge" title={g.external_id || undefined}>
          {groupLabel(g)}
        </li>
      ))}
    </ul>
  );
}
